module.exports = __webpack_public_path__ + "static/media/blog-3.e35ff9f1.png";